import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'

export const useOwnItemDetailsComponentStyles = makeStyles((theme: Theme) =>
  createStyles({
    moderationBanner: {
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: 'orange',
      padding: '1em',
      marginBottom: theme.spacing(2),
    },
    moderationBannerIcon: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    moderationBannerText: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: '1em',
    },
  })
)
